import React from "react";
import { IDataFragment } from "core/components/FragmentProvider";
import { IUserRegistrationFragmetProps, SelectOptions } from "./UserRegistrationForm.panel";
import styled from "styled-components";
import Multiselect from "multiselect-react-dropdown";
import { InputVariant, InputView } from "common/views/input/Input.view";
import Label from "core/components/label/Label";
import { Checkbox, MenuItem } from "@blueprintjs/core";
import { CustomDisplayFragments } from "./customDisplayFragments";
import HtmlDefault from "common/fragments/HtmlDefault";

const StyledDiv = styled.div`
	 {
		display: flex;
		justify-content: flex-start;
		padding: 0.5em;
		width: 50%;
		& > span {
			flex: 2;
		}
		& > div {
			flex: 1;
		}
	}
`;


const StyledConsent = styled.div`
	 {
		flex: 6;
		border: 1px solid black;
		overflow-y: auto;
		overflow-x: hidden;
		height: 200px;
	}
`;

const CommonInput = ({
	Ikey,
	name,
	onChange,
	variant,
	labelDefault,
	placeholder,
	state
}) => {
	let error =  state && state.error && state.error[name] ? 
				 <span className="bp4-text-muted" style={{ color: 'red'}}>{`Please Enter Invalid ${labelDefault}`}</span> :"";
	if (Ikey)
		return (
			<React.Fragment>
				<StyledDiv>
				<span><Label k={Ikey} v={labelDefault} /></span>
					<InputView
						viewKey={Ikey}
						name={name}
						onChange={onChange}
						variant={variant}
						placeholder={placeholder}
						value={state.user[name]}
					/> 
				</StyledDiv>
				{error}
			</React.Fragment>

		);
	return null;
};

const CommonMultiselect = ({
	Ikey,
	labelDefault,
	options,
	displayValue,
	onSelect
}) => {
	if (Ikey)
		return (
			<React.Fragment>
				<StyledDiv>
				<span><Label k={Ikey} v={labelDefault} /></span>
						 <Multiselect
							options={options}
							displayValue={displayValue}
							onSelect={onSelect}
						/> 
				</StyledDiv>
			</React.Fragment>
		);
	return null;
};

export const userName: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "username",
	label: {},
	component: ({ onChange, state }) => {
		return (
				<CommonInput
					Ikey="username"
					labelDefault="Username"
					onChange={onChange}
					name="username"
					variant={InputVariant.TEXT}
					placeholder="username"
					state= {state}
				/>
		);
	}
};

export const password: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "password",
	label: {},
	component: ({ onChange, state }) => {
		return (
			<CommonInput
				Ikey="userRegistrationForm.password"
				labelDefault="Password"
				onChange={onChange}
				name="password"
				variant={InputVariant.PASSWORD}
				placeholder="password"
				state= {state}
			/>
		);
	}
};

export const confirmPassword: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "confirmPassword",
	label: {},
	component: ({ onChange, state }) => {
		return (
			<CommonInput
				Ikey="userRegistrationForm.confirmPassword"
				labelDefault="Confirm Password"
				onChange={onChange}
				name="confirmPassword"
				variant={InputVariant.PASSWORD}
				placeholder="confirmPassword"
				state= {state}
			/>
		);
	}
};

export const firstName: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "firstName",
	label: {},
	component: ({ onChange,  state}) => {
		return (
			<CommonInput
				Ikey="userRegistrationForm.firstName"
				labelDefault="First Name"
				onChange={onChange}
				name="firstName"
				variant={InputVariant.TEXT}
				placeholder="firstName"
				state= {state}
			/>
		);
	}
};

export const lastName: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "lastName",
	label: {},
	component: ({ onChange, state }) => {
		return (
			<CommonInput
				Ikey="userRegistrationForm.lastName"
				labelDefault="Last Name"
				onChange={onChange}
				name="lastName"
				variant={InputVariant.TEXT}
				placeholder="lastName"
				state= {state}
			/>
		);
	}
};

export const email: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "email",
	label: {},
	component: ({ onChange, state }) => {
		return (
			<CommonInput
				Ikey="userRegistrationForm.email"
				labelDefault="Email"
				onChange={onChange}
				name="email"
				variant={InputVariant.TEXT}
				placeholder="Email"
				state= {state}
			/>
		);
	}
};

export const roles: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "roles",
	label: {},
	component: ({ onChange, data }) => {
		return (
			<CommonMultiselect
				Ikey="userRegistrationForm.roles"
				labelDefault="Roles"
				onSelect={(selectList:SelectOptions[])=>{ onChange(null, selectList, "roleIds")}}
				options={data.roles}
				displayValue="label"
			/>
		);
	}
};

export const groups: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "groups",
	label: {},
	component: ({ onChange, data }) => {
		return (
			<CommonMultiselect
				Ikey="userRegistrationForm.groups"
				labelDefault="Groups"
				onSelect={(selectList:SelectOptions[])=>{ onChange(null, selectList, "groupIds")}}
				options={data.groups}
				displayValue="label"
			/>
		);
	}
};

export const privacyConsent: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "privacyConsent",
	label: {},
	component: ({ state, onChange }) => {
		return (
			<StyledDiv>
				<Checkbox
					checked={
						state.user && state.user["privacyConsent"]
							? state.user["privacyConsent"]
							: false
					}
					name="privacyConsent"
					onChange={onChange}
				/>
				<Label k="userRegistrationForm.privacyConsent" v="" />
			</StyledDiv>
		);
	}
};

export const consent: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "consent",
	label: {},
	component: ({data}) => {
		return (
			<StyledDiv>
				<StyledConsent >
				<HtmlDefault
									html={
										data.gdprPolicyMessage
											? data.gdprPolicyMessage
											: "<b>[]</b>"
									}
								/>
				</StyledConsent>
			</StyledDiv>
		);
	}
};


export const customProps: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "Custom  Proprties",
	label: {},
	component: (props) => {
		return (
			<CustomDisplayFragments {...props}/>
		);
	}
};


// WEBPACK FOOTER //
// ./src/panels/userRegistration/displayFragments.tsx